// let api='http://192.168.31.23:5000'
// let api='https://cryptokosh.herokuapp.com'
let api = 'https://endpoint.cryptokosh.com'
// let api='http://localhost:5000'

export default api;